import type { CollapseProps } from "antd";
import { panelStyle } from "./style";

import Info from "./Info";
import DocumentDetail from "./DocumentDetail";

export const DocCategoryContentConstants = {
	INFO: "Kategori Bilgileri",
	DOC_DETAILS: "Dokümanlar"
};

export const DocCategoryItems: CollapseProps["items"] = [
	{
		key: "1",
		label: DocCategoryContentConstants.INFO,
		children: <Info />,
		style: panelStyle,
	},
	{
		key: "2",
		label: DocCategoryContentConstants.DOC_DETAILS,
		children: <DocumentDetail />,
		style: panelStyle,
	}
];
